import Helmet from 'react-helmet';
import { Button, Checkbox, Icon, Loader } from '@/components/ui';
import { useTranslation } from 'react-i18next';

import { useState, useEffect } from 'react';
import { makeRequest } from '@/services/makeRequest';
import { Link } from 'react-router-dom';
import useLadyService from '@/services/LadyService';

import statusElite from '../../../assets/img/status/elite.svg';

import './makeEliteAd.scss';
import { Popup } from '../index';

const MakeEliteAdPopup = (props) => {
	const { open, setOpen, slug: slugProfile } = props;

	const { t } = useTranslation();

	const { lang } = useLadyService();

	const [options, setOptions] = useState([]);

	const [value, setValue] = useState([]);
	const [isLoading, seiIsLoading] = useState(true);

	const handleAddChange = (id) => {
		setValue((prevValue) => {
			if (prevValue.includes(id)) {
				return prevValue.filter((item) => item !== id);
			} else {
				return [...prevValue, id];
			}
		});
	};

	const onClose = () => {
		setValue([]);
		setOpen(false);
	};

	const onSubmit = () => {
		const fetchData = async () => {
			try {
				const route = `user/profile/${slugProfile}/add-friend`;
				const method = 'POST';
				const payload = {
					profiles: value,
				};

				await makeRequest({ route, method, payload });
				onClose();
			} catch (error) {}
		};

		fetchData();
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				seiIsLoading(true);
				const route = `user/profiles`;
				const method = 'GET';
				const payload = {
					limit: 1000,
				};

				const { profiles } = await makeRequest({
					route,
					method,
					payload,
				});
				setOptions(profiles);
				seiIsLoading(false);
			} catch (error) {}
		};

		lang && fetchData();
	}, [lang]);

	return (
		<Popup
			open={open}
			setOpen={onClose}
			method={'POST'}
			wrapperClazz={'popup-form__body_large'}
		>
			<h2>{t('makead')}</h2>
			<div className="popup-form__inner text-center">
				<div className="elite-block__title">
					<picture>
						<source
							srcSet={statusElite}
							media="(min-width: 767.98px)"
						/>
						<img
							src={statusElite}
							alt={t('elite')}
						/>
					</picture>
				</div>

				<span className={'p1'}>
					{t('adelitebonus')}{' '}
					<span className={'color-green'}>
						(+50% {t('toviews')} {t('and')} + 25% {t('toorders')}
						){' '}
					</span>
				</span>
			</div>

			{isLoading ? (
				<Loader />
			) : (
				<div className="elite-block__content">
					{options.map((i) => {
						const { main_photo, id, name } = i;

						return (
							<div
								key={id}
								className="elite-block"
							>
								<img
									src={main_photo}
									alt={name}
								/>

								<Link className="elite-block__link-to">
									{name}
								</Link>
								<Checkbox
									border={false}
									onChange={() => handleAddChange(id)}
									checked={value.includes(id)}
								/>
							</div>
						);
					})}
				</div>
			)}

			<Button
				size={'l'}
				disabled={!value.length}
				onClick={onSubmit}
				clazz={'button--green justify-center mt-auto'}
			>
				{t('confirm')}
			</Button>
		</Popup>
	);
};

export default MakeEliteAdPopup;
